export const TEXT_CHANGED = 'text_changed';

export const USER_LOGIN = "USER_LOGIN";
export const USER_LOGOUT = "USER_LOGOUT";

export const TOKEN_LOAD = "TOKEN_LOAD";
export const TOKEN_RELEASE = "TOKEN_RELEASE";
export const REFRESH_LOAD = "REFRESH_LOAD";
export const REFRESH_RELEASE = "REFRESH_RELEASE";

export const USERS_REQUEST = "USERS_REQUEST";
export const USERS_RESPONSE = "USERS_RESPONSE";
export const USERS_FAIL = "USERS_FAIL";



// WEBPACK FOOTER //
// ./src/Actions/types.js